import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/legal/terminos/page.tsx");
